import axios from 'axios';

const api = axios.create({
  baseURL: `/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

const redirectToLogin = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('role');
  localStorage.removeItem('userId');
  localStorage.removeItem('email');
  localStorage.removeItem('tenantId');
  localStorage.removeItem('name');
  window.location.href = '/login';
};

let refreshRequest = null;

const requestRefreshToken = () => {
  if (!refreshRequest) {
    const refreshToken = localStorage.getItem('refreshToken');
    if (!refreshToken) {
      redirectToLogin();
      return Promise.reject(new Error('Missing refresh token'));
    }
    refreshRequest = axios
      .post('/api/auth/refresh', { refresh_token: refreshToken })
      .finally(() => {
        refreshRequest = null;
      });
  }
  return refreshRequest;
};

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && originalRequest && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const refreshResponse = await requestRefreshToken();
        const data = refreshResponse.data;
        localStorage.setItem('token', data.access_token);
        localStorage.setItem('refreshToken', data.refresh_token);
        localStorage.setItem('role', data.role);
        localStorage.setItem('userId', data.user_id);
        localStorage.setItem('email', data.email);
        if (data.tenant_id) localStorage.setItem('tenantId', data.tenant_id);
        else localStorage.removeItem('tenantId');
        if (data.name) localStorage.setItem('name', data.name);
        else localStorage.removeItem('name');
        api.defaults.headers.Authorization = `Bearer ${data.access_token}`;
        originalRequest.headers.Authorization = `Bearer ${data.access_token}`;
        return api(originalRequest);
      } catch (refreshError) {
        redirectToLogin();
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
